import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import type { Params } from "@/react/helpers/urlHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Paywall } from "@/react/types";
import type { PaywallIndexQueryParams } from "@circle-react/helpers/urlHelpers/internalApi/search/paywalls";
import type { PaywallForm } from "../components/Paywalls/Admin/PaywallsAdmin/types/PaywallForm";

export interface PaywallFormRequest {
  paywall: Partial<PaywallForm>;
  publish: boolean;
}

export interface PaywallResponse extends Paywall {
  access_to_content_changed?: boolean;
}

const search = (params: PaywallIndexQueryParams) => () =>
  reactQueryGet(internalApi.search.paywalls.index(params));

const index = (params: Record<string, string | null>) => () => {
  Object.keys(params).forEach(key => {
    if (params[key] === null) {
      delete params[key];
    }
  });

  return reactQueryGet(
    internalApi.paywalls.index({
      params,
    }),
  );
};

const getPaywall = (
  paywallId: number,
  params: Params = {},
): Promise<PaywallResponse> =>
  reactQueryGet(internalApi.paywalls.show({ paywallId, params }));

const updatePaywall = (
  paywallId: number | undefined,
  params: Partial<PaywallFormRequest>,
): Promise<PaywallResponse> =>
  reactQueryPut(
    internalApi.paywalls.update({
      paywallId: paywallId,
    }),
    params,
  );

const deletePaywall = (
  paywallId: number | undefined,
): Promise<PaywallResponse> =>
  reactQueryDelete(
    internalApi.paywalls.delete({
      paywallId,
    }),
  );

const createPaywall = (params: PaywallFormRequest): Promise<PaywallResponse> =>
  reactQueryPost(internalApi.paywalls.create(), params);

export interface UpdateMemberAccessResponse {
  created_at: string;
  fingerprint: string;
  id: number;
  params: {
    paywall_id: string;
    paywall_spaces_fingerprint: string;
  };
  record_id: number;
  record_type: string;
}
const updateMemberAccess = (
  paywallId: number,
): Promise<UpdateMemberAccessResponse> =>
  reactQueryPost(internalApi.paywalls.updateMemberAccess({ paywallId }));

export const paywallApi = {
  search,
  index,
  getPaywall,
  createPaywall,
  updatePaywall,
  deletePaywall,
  updateMemberAccess,
};
